enum CodeResendStatus {
  Initial,
  Sending,
  Sent,
  Failed,
}

export { CodeResendStatus };
